import React, { useContext } from "react";
import AuthContext from "../../util/AuthContext";
import { useNotification } from "../../util/NotificationContext"; // Import notifications
import { HeartIcon } from "@heroicons/react/24/outline"; // Empty heart
import { HeartIcon as HeartIconFilled } from "@heroicons/react/24/solid"; // Filled heart
import { LinkIcon } from "@heroicons/react/24/outline"; // Share icon

export default function RecipeActions({ recipe }) {
  const { user, login, favorites, addFavorite, removeFavorite } = useContext(AuthContext);
  const { addNotification } = useNotification(); // Use notification context

  // Check if the recipe is already favorited
  const isFavorited = favorites.has(recipe.id);

  const handleFavoriteToggle = () => {
    if (!user) {
      login();
      return;
    }

    if (isFavorited) {
      removeFavorite(recipe.id);
      addNotification("Recipe unsaved", "This recipe has been removed from your favorites.", "success");
    } else {
      addFavorite(recipe.id);
      addNotification("Recipe saved", "You can find it later in My Recipes.", "success");
    }
  };

  const handleCopyLink = () => {
    const recipeUrl = `${window.location.origin}/recipe/${recipe.id}`;
    navigator.clipboard.writeText(recipeUrl);
    addNotification("Link copied", "Share the link with someone.", "success");
  };

  return (
    <div className="flex items-center space-x-2 sm:space-x-4">
      {/* Favorite Button */}
      <button
        onClick={handleFavoriteToggle}
        className="flex items-center space-x-2 text-sm text-gray-700"
      >
        {isFavorited ? (
          <HeartIconFilled className="w-6 h-6 text-green-600 hover:text-green-700" />
        ) : (
          <HeartIcon className="w-6 h-6 text-gray-500 hover:text-green-600 transition duration-300" />
        )}
      </button>

      {/* Share Button */}
      <button
        onClick={handleCopyLink}
        className="flex items-center space-x-2 text-sm text-gray-700 hover:text-green-600 transition duration-300"
      >
        <LinkIcon className="w-5 h-5" />
      </button>
    </div>
  );
}
